import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

function buildDefaultTimeOptions(): string[] {
  const options: string[] = [];
  for (let hour = 0; hour < 24; hour++) {
    for (const minute of [0, 30]) {
      options.push(`${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`);
    }
  }
  options.push('23:59');
  return options;
}

@Component({
  selector: 'app-hour-select-field',
  templateUrl: './hour-select-field.component.html',
  styleUrls: ['./hour-select-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HourSelectFieldComponent {
  @Input() control!: FormControl<string | null>;
  @Input() label = '';
  @Input() placeholder = '00:00';
  @Input() tooltip = '';
  @Input() errorMessage = '';
  @Input() timeOptions: string[] = buildDefaultTimeOptions();
  @Input() dataTest = 'hora';

  @ViewChild('box') private boxRef!: ElementRef<HTMLDivElement>;

  panelOpen = false;
  panelWidth = 0;

  get tooltipDisabled(): boolean {
    return !this.control || this.control.enabled;
  }

  togglePanel(): void {
    if (this.control?.disabled) return;
    this.panelWidth = this.boxRef.nativeElement.offsetWidth;
    this.panelOpen = !this.panelOpen;
  }

  closePanel(): void {
    this.panelOpen = false;
  }

  selectTime(time: string): void {
    this.control.setValue(time);
    this.closePanel();
  }

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let digits = input.value.replace(/\D/g, '').slice(0, 4);

    if (digits.length >= 2) {
      const hour = Math.min(parseInt(digits.slice(0, 2), 10), 23);
      digits = String(hour).padStart(2, '0') + digits.slice(2);
    }
    if (digits.length >= 4) {
      const minute = Math.min(parseInt(digits.slice(2, 4), 10), 59);
      digits = digits.slice(0, 2) + String(minute).padStart(2, '0');
    }

    const formatted = digits.length > 2 ? `${digits.slice(0, 2)}:${digits.slice(2)}` : digits;
    input.value = formatted;
    this.control.setValue(formatted, { emitEvent: false });
  }

  trackByTime(_: number, time: string): string {
    return time;
  }
}
